import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { rejectQuotationThunk, resetDataRejectQuotation } from "redux/Reducers/Concierge/rejectQuotationSlicer";

import { useForm } from "antd/es/form/Form";

import "Assets/styles/default/components/Concierge/Modals/RejectQuotationModal.less"

import { Col, Form, Row, VertButton, VertInput, VertModal, VertTypography, notification } from "@vertem-core/vertice-ds";

const RejectQuotationModal = (props) => {
  const { isOpen, setIsOpen, solicitationId, onSuccess } = props;

  const [note, setNote] = useState();

  const [ form ] = useForm();

  const dispatch = useDispatch();

  const {
    dataRejectQuotation,
    loadingRejectQuotation,
    errorRejectQuotation,
  } = useSelector(state =>
    state.RejectQuotation
  );

  const validations = {
    note: {
      rules: [{
        required: true,
        message: "Campo obrigatório."
      }]
    }
  };

  const handleNoteChange = (value) => {
    setNote(value);
  }

  const handleSubmit = () => {
    form.validateFields().then(() => {
      const reject = {
        solicitationId,
        note,
      };

      dispatch(rejectQuotationThunk(reject));
    }).catch(() => {
      notification.error({
        message: "Preencha os campos corretamente.",
      });
    })
  }

  useEffect(() => {
    if (!dataRejectQuotation) return;

    setIsOpen(false);

    notification.success({
      message: "A cotação foi rejeitada."
    });

    onSuccess();
  }, [dataRejectQuotation]);

  useEffect(() => {
    if(!errorRejectQuotation) return;

    notification.error({
      message: "Houve um erro ao rejeitar cotação, tente novamente."
    });

    dispatch(resetDataRejectQuotation());

  }, [errorRejectQuotation]);

  return (
    <VertModal
      className="concierge-reject-quotation-modal"
      width={"50%"}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      destroyOnClose={true}
    >
      <Row>
        <Col>
          <VertTypography.Title>
            Você deseja rejeitar a cotação realizada?
          </VertTypography.Title>
        </Col>
      </Row>

      <Row>
        <Col>
          <VertTypography.Paragraph type="light">
            Ao confirmar esta ação, a cotação será rejeitada.
          </VertTypography.Paragraph>
        </Col>
      </Row>

      <Form form={form}>
        <Form.Item
          name="note"
          rules={validations.note.rules}
        >
          <VertInput.TextArea
            className="note"
            placeholder="Descreva o motivo da rejeição"
            value={note}
            onChange={(e) => handleNoteChange(e.target.value)}
          /> 
        </Form.Item>
      </Form>

      <Row className="actions" justify="end">
        <Col className="action-btn-group">
          <VertButton
            className="button-concierge"
            onClick={() => setIsOpen(false)}
          >
            Cancelar
          </VertButton>

          <VertButton
            className="btn-confirm"
            type="highlight"
            loading={loadingRejectQuotation}
            onClick={handleSubmit}
          >
            Confirmar
          </VertButton>
        </Col>
      </Row>
    </VertModal>
  )
}

export default RejectQuotationModal;